<template>
  <div class="proposal-page" v-if="loaded">
    <Hero
      theme="black"
      epigraph=""
      :title="propData.title"
      :description="propData.excerpt"
      :price="propData.price"
      :postcardImage="propData.postcards[0].image[0]"
      :image="propData.level1_gallery['frontal-view-side'] ? propData.level1_gallery['frontal-view-side'] : false"
      :button="propData.button"
      :secondLine="propData.price2"
    />

    <Recipient :data="propData"></Recipient>

    <!-- <Overview :postcardImage="propData.postcards[0].image[0]"></Overview> -->

    <Products :data="propData"></Products>

    <BrandingCase v-if="propData.branding && propData.branding.case" :data="propData.branding" />

    <BrandingPostcard v-if="propData.branding && propData.branding.postcard" :data="propData.branding" />

    <Postcard v-if="propData.show_postcards === '1'" :data="propData"></Postcard>

    <Packaging :image="propData.level1_gallery['half-open'] ? propData.level1_gallery['half-open'] : false"></Packaging>
  </div>
</template>

<script>
/**
 * Proposal Page View
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Proposal/Angebot page for businesses
 * @since 2020-11-11
**/

import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';

import Hero from '@/components/proposal-page/Hero';
import Recipient from '@/components/proposal-page/Recipient';
// import Overview from '@/components/proposal-page/Overview';
import Products from '@/components/proposal-page/Products';
import BrandingCase from '@/components/proposal-page/BrandingCase';
import BrandingPostcard from '@/components/proposal-page/BrandingPostcard';
import Postcard from '@/components/proposal-page/Postcard';
import Packaging from '@/components/proposal-page/Packaging';
import { TrackingMixin } from '@/mixins/TrackingMixin';

export default {
  name: 'ProposalPageLegacy',
  components: {
    Hero,
    Recipient,
    // Overview,
    Products,
    BrandingCase,
    BrandingPostcard,
    Postcard,
    Packaging
  },
  mixins: [TrackingMixin],
  props: ['prop'],
  data: function () {
    return {
      loaded: false,
      propData: {}
    };
  },
  created: function () {
    this.$store.commit('setGlobalLoading', true);
    this.criteoTracking({ event: 'viewPage' });
    AOS.init({
      once: true
    });

    window.addEventListener('load', AOS.refresh);

    axios
      .get(
        process.env.VUE_APP_BASE_URL +
          '/wp-json/geschenkbox/v1/get_proposal?prop=' + this.prop
      )
      .then((response) => {
        this.propData = response.data;
        this.loaded = true;
        this.$store.commit('setGlobalLoading', false);
      });
  }
};
</script>

<style lang="scss">
body.page-id-2778 .page.type-page {
  padding-top: 0 !important;
}
body.page-id-2778 .elementor .elementor-element-d54cdc3 {
  display: none !important;
}
</style>

<style lang="scss" scoped>
/**
 * Proposal Page View
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Proposal/Angebot page for businesses
 * @since 2020-11-11
**/

// Rules for affecting child components
::v-deep {
  // @import '../assets/styles/lib/source-sans-webfont/source-sans';
  // @import '../assets/styles/lib/frank-ruhl-webfont/frank-ruhl';

  // @include font-size(map-get($proposal-page, 'font-size-base'));

  // PP special container and its variants
  .pp-container {
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1em;
    padding-right: 1em;

    &.--is-narrow {
      padding-left: 8%;
      padding-right: 8%;
    }

    // Flexboxgrid hacks
    .row {
      margin-left: -1em;
      margin-right: -1em;

      div[class^='kol-'] {
        padding-left: 1em;
        padding-right: 1em;
      }
    }
  }

  // Titles
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
  }
}

// Variables
$component: 'proposal-page';

// Component
.#{$component} {
  background-color: $white;

  // Affecting child component's "section" areas
  ::v-deep & {
    &__section {
      width: 100%;
      @include padding-top(map-get($spacers, 4) * 4);
      @include padding-bottom(map-get($spacers, 4) * 4);

      &.--has-no-padding {
        padding: 0;
      }
    }

    // When sections have cutting areas, they act as a standalone section in terms of spacing, paddings and margins
    &__cut {
      @include margin-top(- map-get($spacers, 4) * 4);
      @include margin-bottom(- map-get($spacers, 4) * 4);
      @include padding-top(map-get($spacers, 4) * 4);
      @include padding-bottom(map-get($spacers, 4) * 4);
    }

    &__section-heading {
      @include margin-bottom(map-get($spacers, 4) * 3);
      text-align: center;
    }

    &__section-title {
      @include margin-bottom(map-get($spacers, 4));
      @include font-size(map-get($proposal-page, 'font-size-title'));
    }

    &__section-description {
      @include font-size(map-get($proposal-page, 'font-size-lg'));
      line-height: 170%;
      font-weight: $font-weight-light;
    }

    // ——————————————————————————————
    // Max MD
    // ——————————————————————————————
    @media (max-width: map-get($proposal-page, 'viewport-md')) {
      &__section-heading {
        @include margin-bottom(map-get($spacers, 4) * 5);
      }
    }

    // ——————————————————————————————
    // Max SM
    // ——————————————————————————————
    @media (max-width: map-get($proposal-page, 'viewport-xs')) {
    }
  }
}
</style>
